import api from "./client";

/* Marketing attribution report — bound to analytics_app.
   Contract of record: docs/MARKETING_REPORT_FRONTEND_CONTRACT.md (lane E).
   The endpoint is LIVE-computed on every call (is_live + generated_at); it is
   on origin/main (analytics_app/urls.py) but was NOT in the deployed backend
   at build time (a0aed65c → 404). The screen renders an honest "not deployed
   yet" state on 404 — never sample data — and lights up on the next deploy. */

// GET /api/analytics/attribution-report/ — all params optional:
// start, end (ISO) · service · campaign · landing_path · tech (SOLD-BY rep user id; the
// backend filters lead.sales_rep_user_id) · technician (roster id — PENDING on the backend,
// the UI shows a note until data.filters echoes it; docs/MARKETING_REPORT_UI_ASKS_2026-09-08.md)
export const getAttributionReport = (params = {}) =>
  api.get("/analytics/attribution-report/", { params });
